





































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import consts from "../consts";

@Component
export default class SSO extends Vue {
  //private companyName: string = "";
  private linkingCompany: boolean = false;
  private linkingError: boolean = false;
  private loggingIn: boolean = false;
  @Prop() private email!: string;

  private linkCompany() {
    axios
      .get(
        consts.serverURL +
          "saml/sso/email/" +
          this.email +
          "?relay=" +
          window.location.hostname +
          "&customtarget=" +
          window.location.origin
      )
      .then(resp => {
        // console.log("LINK COMPANY", resp.data);
        if (resp.data.URL) {
          window.location = resp.data.URL;
        }
      })
      .catch(reason => {
        console.log(reason, reason.response);
        this.linkingError = true;
      });
  }

  private handleSSOClick() {
    this.linkingCompany = true;
    this.linkingError = false;
    this.email = "";
  }

  private getCompanyName(email: string): string {
    if (!email || email.length === 0) {
      return "";
    }
    const temp = email.replace(/.*@/, "").split(".");
    return temp[temp.length - 2];
  }

  private handleCancelClick() {
    this.linkingCompany = false;
  }
}
